/* eslint-disable */
import React from 'react';

const messageConstructor =
    className =>
    ({ message }) =>
        (
            <div className={className}>
                <span>{message}</span>
            </div>
        );

const ErrorMessage = messageConstructor('error-message');
const SuccessMessage = messageConstructor('success-message');

export { ErrorMessage, SuccessMessage };
